<!-- global markup for header -->
<header class="header" #header>
	<div class="content">
		<div class="header__block row">
			<div class="header__arrow col image" (click)="goBack()"><img src="/assets/images/header/back-arrow.svg" alt="arrow" /><span style="color: white; font-size: 18px">חזרה</span></div>

			<div class="header__title col">{{ reportName }}</div>
			<div class="header__burger col image"></div>
		</div>
	</div>
</header>

<!-- start report table markup -->
<section class="report-table" style="margin-top: 50px">
	<div class="flex-row" *ngIf="!loading">
		<div class="box" style="position: absolute; left: 0">
			<app-excel-button></app-excel-button>
		</div>
	</div>
	<div class="content">
		<div class="report-table__row report-table__row_full-width custom-scrollbar" style="margin-right: 0px; width: 100%">
			<h1 *ngIf="loading; else loadedBlock">טוען...</h1>

			<ng-template #loadedBlock>
				<h1 *ngIf="!displayValues.length; else tableBlock">לא נמצאו תוצאות</h1>
				<ng-template #tableBlock>
					<table class="report-table__table" cellspacing="0">
						<thead class="report-table__table-head">
							<tr>
								<th class="report-table__table-head-name" style="width: 150px" *ngFor="let header of headers">{{ header }}</th>
							</tr>
						</thead>
						<tbody class="report-table__table-body">
							<tr *ngFor="let a of displayValues; index as i">
								<td class="report-table__table-body-name" *ngFor="let property of headers">{{ a[property] }}</td>
							</tr>
						</tbody>
					</table>
				</ng-template>
			</ng-template>
		</div>
	</div>
</section>
<!-- end report table markup -->
